/**
 * 格式化秒数为时间字符串
 * @param {number} seconds - 秒数
 * @returns {string} 格式化后的时间字符串，格式为 HH:MM:SS 或 MM:SS
 */
export const formatTime = seconds => {
  if (!seconds || seconds < 0) return '00:00:00'

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = Math.floor(seconds % 60)

  const pad = num => String(num).padStart(2, '0')

  return `${hours === 0 ? '' : pad(hours) + ':'}${pad(minutes)}:${pad(secs)}`
}

export const getCookie = () => {
  return document?.cookie
}
export function processNumber(num: number) {
  if (num >= 10000) {
    return (num / 10000).toFixed(1) + '万'
  }
  return num
}
export const getCookieVal = (cookieName: string) => {
  const cookie = getCookie()

  const arrstr = cookie.split('; ')
  for (let i = 0; i < arrstr.length; i = i + 1) {
    const kv = arrstr[i].split('=')
    if (kv[0] === cookieName) return decodeURIComponent(kv[1])
  }
  return ''
}
